// Musteri aktivite log API — admin panel icin.
// Backend interceptor /musteri, /odeme, /noktalar-genel prefixleri icin yazar.
function ds(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.musteriId)
        p.set('musteriId', s.musteriId);
    if (s.endpoint)
        p.set('endpoint', s.endpoint);
    if (s.baslangic)
        p.set('baslangic', s.baslangic);
    if (s.bitis)
        p.set('bitis', s.bitis);
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function aktiviteKayitlariniListele(istemci, sorgu = {}) {
    return istemci.istek(`/aktivite${ds(sorgu)}`);
}
//# sourceMappingURL=aktivite.js.map